<svg class="cm-loading-icon" [attr.width]="size" [attr.height]="size"
	[attr.viewBox]="'0 0 ' + size.toString() + ' '  + size.toString()" xmlns="http://www.w3.org/2000/svg"
	stroke="currentColor">
	<g fill="none" fill-rule="evenodd" transform="translate(1 1)" [attr.stroke-width]="stroke">
		<circle [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" stroke-opacity="0">
			<animate attributeName="r" begin="1.5s" dur="3s" [attr.values]="outerCirc" calcMode="linear"
				repeatCount="indefinite" />
			<animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear"
				repeatCount="indefinite" />
			<animate attributeName="stroke-width" begin="1.5s" dur="3s" values="1;0" calcMode="linear"
				repeatCount="indefinite" />
		</circle>
		<circle [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" stroke-opacity="0">
			<animate attributeName="r" begin="3s" dur="3s" [attr.values]="outerCirc" calcMode="linear"
				repeatCount="indefinite" />
			<animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear"
				repeatCount="indefinite" />
			<animate attributeName="stroke-width" begin="3s" dur="3s" values="1;0" calcMode="linear"
				repeatCount="indefinite" />
		</circle>
		<circle *ngIf="hasInnerCirc" [attr.cx]="center" [attr.cy]="center" [attr.r]="radius + 2">
			<animate attributeName="r" begin="0s" dur="1.5s" [attr.values]="innerCirc" calcMode="linear"
				repeatCount="indefinite" />
		</circle>
	</g>
</svg>
